/**
* this is the component for the transaction list
*
* Created by Tom on 15/06/18
*/

import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import ReactTable from "react-table"
import "react-table/react-table.css"

import { intlNumberFormatter } from '../../utility/utilities'

// action import
import { ActionCreator } from '../../actions/'

// component import
import CustomDatePicker from '../../components/CustomDatePicker/'

// icon imports
import CalendarIcon from '../../assets/svg/calendar.svg'

// style import
import './style.scss'

// import the table column definitions
import tableColumns from './tableColumns'


class Transaction extends Component {

    constructor() {
        super()
        this.state = {
            effectiveWidth: 0
        }
    }

    componentDidMount() {
        window.addEventListener("resize", ::this._determineWidth)
    }

    componentWillUnmount() {
        window.removeEventListener("resize", ::this._determineWidth)
    }

    componentDidUpdate(prevProps, prevState) {
        const { effectiveWidth } = this.state

        if((prevState.effectiveWidth !== effectiveWidth) || (effectiveWidth === 0))
            this._determineWidth()
    }

    /*
        in order to display the horizontal scroll bar of the table wrapper
        (className="transaction__table-wrapper") we need to provide a width
        value. we get this value dynamically from the it's parent

        the width value will be save in the local state var effectiveWidth
    */
    _determineWidth() {
        const { effectiveWidth } = this.state
        // it's not guaranteed that all components have finished rendering
        // so we need to set a timeout to queue the findDOMNode() function
        setTimeout(() => {
            // get the width of this component
            const width = document.getElementsByClassName("dashboard__display-box")[0].offsetWidth
            // only update state if the width has changed
            if(effectiveWidth !== width)
                ::this.setState({effectiveWidth: (width - 60)})
        }, 0)
    }

    _onStartDateChange(date) {
        const { setTransactionStartDate } = this.props
        // set the start date in store
        setTransactionStartDate(date)
    }

    _onEndDateChange(date) {
        const { setTransactionEndDate } = this.props
        // set the end date in store
        setTransactionEndDate(date)
    }

    _onClearClick(e) {
        const { clearDateRange } = this.props
        // do not refresh page
        e.preventDefault()
        e.stopPropagation()
        // reset the date range
        clearDateRange()
    }

    render() {

        const { tStartDate, tEndDate, tData, tClosingBalance } = this.props
        const { effectiveWidth } = this.state

        // populate closing balance string i.e. $34,456
        const closingBalance = intlNumberFormatter('en-AU', 'currency', 'AUD', tClosingBalance)

        return (
            <div
                className="transaction"
                ref={componentRef => this.transactionDIV = componentRef}>

                {/* header container*/}
                <div className="transaction__header">

                    <div className="transaction__header__title">
                        <p>TRANSACTION AMOUNT</p>
                    </div>

                    <div className="transaction__header__balance">
                        <p className="transaction__header__balance__amount">
                            BALANCE:&nbsp;&nbsp;&nbsp;{closingBalance}
                        </p>
                        <p className="transaction__header__balance__descr">
                            Closing balance from yesterday
                        </p>
                    </div>

                </div>

                {/* date range container*/}
                <div className="transaction__date-range">

                    {/* date range description */}
                    <div className="transaction__date-range__title">
                        <p>Date range</p>
                    </div>

                    {/* container that contains the pcikers and clear link */}
                    <div className="transaction__date-range__picker-container">

                        <div className="transaction__date-range__picker-start">
                            {/* datepicker component for start date */}
                            <CustomDatePicker
                                icon={CalendarIcon}
                                date={tStartDate}
                                dateFormat="DD MMM YY"
                                onDateChange={::this._onStartDateChange} />
                        </div>

                        {/* datepicker component for end date */}
                        <CustomDatePicker
                            icon={CalendarIcon}
                            date={tEndDate}
                            dateFormat="DD MMM YY"
                            onDateChange={::this._onEndDateChange} />

                        {/* date range clear link */}
                        <a
                            href=""
                            className="transaction__date-range__clear"
                            onClick={::this._onClearClick}>
                            Clear
                        </a>

                    </div>

                </div>

                {/* table wrapper for horizontal scolling */}
                <div
                    className="transaction__table-wrapper"
                    style={{width: effectiveWidth}}>

                    {/* https://react-table.js.org/#/story/simple-table */}
                    <ReactTable
                        className="tTable -highlight"
                        noDataText="No transactions available"
                        showPagination={false}
                        resizable={false}
                        defaultPageSize={10}
                        data={tData}
                        columns={tableColumns}
                    />

                </div>

            </div>
        )
    }
}

// define the prop types
Transaction.propTypes = {
    setTransactionStartDate: PropTypes.func.isRequired,
    setTransactionEndDate: PropTypes.func.isRequired,
    tClosingBalance: PropTypes.number, // although it's a FLOAT
    clearDateRange: PropTypes.func.isRequired,
    tStartDate: PropTypes.object,
    tEndDate: PropTypes.object,
    tData: PropTypes.array
}

// pull props to this container
const mapStateToProps = (state) => {
    return {
        tClosingBalance: state.transactionState.tClosingBalance,
        tStartDate: state.transactionState.tStartDate,
        tEndDate: state.transactionState.tEndDate,
        tData: state.transactionState.tData
    }
}

// pull all required action creators into this container
const mapDispatchToProps = (dispatch) => {
    const action = bindActionCreators(ActionCreator, dispatch)
    return {
        setTransactionStartDate: action.setTransactionStartDate,
        setTransactionEndDate: action.setTransactionEndDate,
        clearDateRange: action.clearDateRange
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Transaction)



// WEBPACK FOOTER //
// ./src/components/Transaction/index.js